import MerchantPaymentsService from '../../../../services/MerchantPaymentsService';
import { useLoaderContext } from '../../../../contexts/Loader/LoaderContext';
import Timer from '../../../../Utils/Timer';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

const useQuerySummaryPayments = ({
  startDateRange = '',
  endDateRange = '',
}) => {
  const { setIsLoaderOpen } = useLoaderContext();

  const fetchPayments = async paymentsOptions => {
    try {
      setIsLoaderOpen(true);
      const response =
        await MerchantPaymentsService().getPayments(paymentsOptions);

      window.localStorage.setItem(
        'paymentHistory',
        JSON.stringify({
          filters: { startDate: startDateRange, endDate: endDateRange },
          lastSync: Timer().toNowISO(),
          summary: response?.summary,
        })
      );

      return response?.summary;
    } catch (error) {
      console.error('Error fetching summary payments:', error);
    } finally {
      setIsLoaderOpen(false);
    }
  };

  const queryResult = useQuery({
    queryKey: ['summaryPayments', startDateRange, endDateRange],
    queryFn: async () =>
      fetchPayments({
        page: 1,
        limit: 20,
        startDateRange,
        endDateRange,
      }),
    placeholderData: keepPreviousData,
  });

  return queryResult;
};

export default useQuerySummaryPayments;
